import React from 'react'
import MainSlider from '~/main/components/MainSlider'
import Lineup from '~/programs/components/Lineup';
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';
import FortyFive from '~/main/components/45';
import FromAToTripleZed from '~/features/components/FromAToTripleZed';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import TopSection from './TopSection'
import RadiothonBanner from './RadiothonBanner2022'
import Events from './Events'
import SubPacks from './SubPacks'
import MajorPrizes from './MajorPrizes'
import StationUpdates from './StationUpdates'
import DailyPrize from './DailyPrize'
import About from './About'
import Top20Feature from './Top20Feature'
import AOTW from './AOTW'
import BNA from './BNA'
import Prizes from './Prizes'
import Hot100 from './Hot100'
import EOYTop10 from './EOYTop10'
import Footer from './Footer'
import { fetchTop20IfNeeded, fetchTop20Counter } from '~/features/actions'
import { onAirFM, onAirZD, fetchFMProgramsIfNeeded, fetchZDProgramsIfNeeded, fetchFortyFive, fmLineup } from '~/programs/actions'
import { fetchBNAIfNeeded, fetchAOTWIfNeeded, fetchRadiothonDailyIfNeeded, fetchStationUpdatesIfNeeded, fetchEOYTop10IfNeeded, fetchPrizesIfNeeded } from '~/features/actions'
import { fetchEventsIfNeeded } from '~/events/actions'

class Radiothon2022 extends React.Component{

  static fetchData(store) {
    return Promise.all([
      store.dispatch(onAirFM()),
      store.dispatch(onAirZD()),
      store.dispatch(fetchFMProgramsIfNeeded()),
      store.dispatch(fetchZDProgramsIfNeeded()),
      store.dispatch(fetchTop20IfNeeded()),
      store.dispatch(fetchStationUpdatesIfNeeded()),
      store.dispatch(fetchEventsIfNeeded()),
      store.dispatch(fetchBNAIfNeeded()),
      store.dispatch(fetchAOTWIfNeeded()),
      store.dispatch(fetchEOYTop10IfNeeded()),
      store.dispatch(fetchPrizesIfNeeded()),
			store.dispatch(fetchFortyFive()),
    ]).then( () => {
		  return store.dispatch(fmLineup());
		}).then ( 
      () => { 
        console.log('all promises')
      }
    )
  }

  render() {
    const {programsFM, programsZD, onAirFM, onAirZD, programs, selectedEpisodeDate, radiothonDaily, stationUpdates, search} = this.props

    var settings = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 100,
      slidesToScroll: 1,
      fade: false,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    }

    const dailyPrize = radiothonDaily.items.map( ( item, index) =>
      <div onClick={(e) => this.clicked(item, e)} className='daily-prize' key={index}>
        <img src={item.field_event_image[0].url} style={{maxWidth: '100%', float: 'left'}} />
        <h3>{item.title[0].value}</h3>
        <div dangerouslySetInnerHTML={{ __html: item.body[0].value }}></div>
        {/*<div>{item.field_event_teaser[0].value}</div>*/}
        <div style={{clear: 'both' }} />
      </div>
    )
		const sliderImage = { width: '275px', height: 'auto' }

    if (programsFM.lastUpdated> 0 && onAirFM.program !== null ) {
      return (
      <div className='main-front'>
        <RadiothonBanner />
        <TopSection />
        <Prizes />
        <SubPacks />
        <Lineup />
				<FortyFive />
        <FromAToTripleZed />
        <AOTW />
        {/* <BNA /> */}
        <Top20Feature />
        <StationUpdates />
        <Events />
        <Footer />
      </div>
      )
    } else {
      return ( null )
    }
  }
}

const dispatchToProps = (dispatch) => {
    return bindActionCreators({
      fetchEventsIfNeeded,
      receiveEvents
    }, dispatch)
}

const mapDispatchToProps = {
}

function mapStateToProps(state) {
  const { events, programsFM, onAirFM, radiothonDaily, stationUpdates } = state
  const {
    isFetching,
    lastUpdated,
    items
  } = events || {
    isFetching: true,
    items: []
  }
 
  return {
    events, programsFM, onAirFM, radiothonDaily, stationUpdates
  }
}

//export default connect(dispatchToProps)(Main)
export default connect(mapStateToProps)(Radiothon2022)
